import { render, staticRenderFns } from "./ClientePedidos.vue?vue&type=template&id=30f17bd0&"
import script from "./ClientePedidos.vue?vue&type=script&lang=js&"
export * from "./ClientePedidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports